import { IApi } from "./types";

export let dataSource:IApi;

export function setDataSource(src:IApi) {
    dataSource = src;
}